export default __webpack_public_path__ + "static/media/David.9423a842.png";